// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fadein, #btn_delete_temp {
  animation: fadein 0.3s;
}

.fadeout {
  animation: fadeout 0.3s;
}

@keyframes fadein {
  from {
    opacity: 0;
    transform: translate3d(0, -0.5rem, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
ul.user-details-list {
  padding: 0;
  list-style-type: none;
}
ul.user-details-list .user-details-list-item {
  padding: 0.25rem 1rem;
}

#small-version-display {
  text-align: right;
  font-size: 0.7rem;
}

.cursor-pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/base/common/_animations.scss","webpack://./src/app/core/header/header.component.scss"],"names":[],"mappings":"AA6CA;EACE,sBAAA;AC5CF;;AD8CA;EACE,uBAAA;AC3CF;;AD8CA;EACE;IACE,UAAA;IACA,qCAAA;EC3CF;ED6CA;IACE,UAAA;IACA,+BAAA;EC3CF;AACF;AD6CA;EACE;IACE,UAAA;EC3CF;ED6CA;IACE,UAAA;EC3CF;AACF;AAvBA;EACE,UAAA;EACA,qBAAA;AAyBF;AAvBE;EACE,qBAAA;AAyBJ;;AArBA;EACE,iBAAA;EACA,iBAAA;AAwBF;;AAjBA;EACE,eAAA;AAoBF","sourcesContent":["// // Common properties\r\n// .animation {\r\n//   animation-duration: 1s;\r\n//   animation-fill-mode: forwards;\r\n//   animation-timing-function: ease-in-out;\r\n// }\r\n\r\n// // APPEAR\r\n\r\n// .appear {\r\n//   @extend .animation;\r\n//   height: 100%;\r\n//   animation-name: appearAnimation;\r\n// }\r\n\r\n// @keyframes appearAnimation {\r\n//   0% {\r\n//     height: 0%;\r\n//     // top: -100%;\r\n//   }\r\n//   100% {\r\n//     height: 100%;\r\n//     // top: 0;\r\n//   }\r\n// }\r\n\r\n// // DISAPPEAR\r\n\r\n// .disappear {\r\n//   @extend .animation;\r\n//   height: 0%;\r\n//   animation-name: disappearAnimation;\r\n// }\r\n\r\n// @keyframes disappearAnimation {\r\n//   0% {\r\n//     // top: 0;\r\n//     height: 100%;\r\n//   }\r\n//   100% {\r\n//     // top: -100%;\r\n//     height: 0;\r\n//   }\r\n// }\r\n\r\n.fadein {\r\n  animation: fadein 0.3s;\r\n}\r\n.fadeout {\r\n  animation: fadeout 0.3s;\r\n}\r\n\r\n@keyframes fadein {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate3d(0, -0.5rem, 0);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n@keyframes fadeout {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n","@import '../../styles/base/common/animations';\r\n\r\nul.user-details-list {\r\n  padding: 0;\r\n  list-style-type: none;\r\n\r\n  .user-details-list-item {\r\n    padding: 0.25rem 1rem;\r\n  }\r\n}\r\n\r\n#small-version-display {\r\n  text-align: right;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n#btn_delete_temp {\r\n  @extend .fadein;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
